import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

export default class AIManager {
    constructor() {
        this.config = null;
        this.lib = window.LivingScript_0070;
        this.aiEvents = new Subject();
        this.aiChannels = {};
    }  
    
    init(params, callback) {
        console.log("AI Manager Init : ", params);
        if(params.Client) {
            this.config = params;
            this.aiChannels[params.Client] = this.aiEvents.pipe(filter((event) => event.ClientID == params.Client));
            window.BotServices.PageState.next({Client : params.Client, State : 'aiInit'});
            callback(null, "AI Manager Initiated");
            //this.test();
        } else {
            callback("Invalid Client ID", null);
        }


        // const paths = this.click.pipe(
        //     map(event => {
        //       // Use event.path or event.composedPath() for cross-browser compatibility
        //       const path = event.path || (event.composedPath && event.composedPath());
        //       // Create a selector path to the clicked element
        //       const pathSelectors = path.map(element => {
        //         if (element.id) {
        //           return `#${element.id}`; // Use ID if available, since it's unique
        //         } else if (element.className && typeof element.className === 'string' && element.className.trim() !== '') {
        //           return `.${element.className.split(' ').join('.')}`; // Use class names if available
        //         } else if (element.tagName) {
        //           return element.tagName.toLowerCase(); // Use tag name as a fallback
        //         }
        //         return null;
        //       }).filter(Boolean).join(' > ');
          
        //       return pathSelectors;
        //     })
        //   );
          
        //   // Subscribe to the paths$ Observable to log the path for each click event
        //   paths.subscribe(pathSelectors => {
        //     console.log(pathSelectors, "==>");
        //   });
        // setInterval(() => { this.aiPublish({ClientID : params.Client, data : "Hello World"}); }
        // , 10000);
    }

    aiPublish(event) {
        console.log("AI Publish Event : ", event);
        this.aiEvents.next(event);
    }

    getAiChannel(ClientID) {
        if(this.aiChannels[ClientID]) {
            return this.aiChannels[ClientID];
        } else {
            return null;
        }        
    }

    // test() {
    //     this.aiChannel.subscribe((event) => {
    //         console.log("AI Channel Event : ", event);
    //     });
    // }
}